(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ManagementIntensityController = (function(superClass) {
    extend(ManagementIntensityController, superClass);

    function ManagementIntensityController(scope, transitions, modal, http, service, state) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.multipleRxMapsDeliveredForField = bind(this.multipleRxMapsDeliveredForField, this);
      ManagementIntensityController.__super__.constructor.apply(this, arguments);
    }

    ManagementIntensityController.prototype.multipleRxMapsDeliveredForField = function(fieldSurvey) {
      var ref;
      return fieldSurvey.data.management_intensity === 'Intense' && ((ref = this.service.rxMaps[fieldSurvey.fields_id]) != null ? ref.length : void 0) > 1;
    };

    return ManagementIntensityController;

  })(Controller);

}).call(this);
